import React from "react";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { Box, Typography, Container } from "@mui/material";
import { useTheme } from "../../contexts/ThemeContext";
import PerformanceDetails from "./PerformanceDetails";

const PerformanceDashboard = () => {
  const { currentTheme } = useTheme();

  return (
    <>
      <Helmet>
        <title>Performance Dashboard | Vantage Alpha</title>
      </Helmet>

      <Box
        sx={{
          backgroundColor:
            currentTheme.palette.mode === "light"
              ? "#ebebeb"
              : currentTheme.palette.grey[50],
          background:
            currentTheme.palette.mode === "light"
              ? "#ebebeb"
              : currentTheme.palette.grey[50],
          minHeight: "100vh",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Box sx={{ mb: 3 }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 600,
                color: currentTheme.palette.text.primary,
                mb: 1,
              }}
            >
              Performance Dashboard
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: currentTheme.palette.text.secondary,
              }}
            >
              Comprehensive view of fund and strategy performance metrics
            </Typography>
          </Box>

          <PerformanceDetails />
        </Container>
      </Box>
    </>
  );
};
export default PerformanceDashboard;
